module.exports = __webpack_public_path__ + "static/media/foto1.ac173138.png";